/**
 * StreamMate Web App 配置文件
 */

// API 配置
export const API_CONFIG = {
  // 默认 API 基础URL (开发环境使用本地CORS代理)
  BASE_URL: process.env.NODE_ENV === 'development' 
    ? 'http://localhost:3001/streammate/api'
    : (process.env.REACT_APP_API_BASE_URL || 'https://streammate.website/api'),
  
  // 请求超时时间（毫秒）
  TIMEOUT: 300000, // 增加到5分钟，确保下载大文件时有足够时间
  
  // 是否启用调试模式
  DEBUG: process.env.REACT_APP_DEBUG === 'true' || process.env.NODE_ENV === 'development'
};

// 应用配置
export const APP_CONFIG = {
  // 应用名称
  NAME: 'StreamMate',
  
  // 应用版本
  VERSION: '1.0.0',
  
  // 支持的平台
  SUPPORTED_PLATFORMS: [
    { name: 'YouTube', domains: ['youtube.com', 'youtu.be'], icon: '🎬' },
    { name: 'Twitter/X', domains: ['twitter.com', 'x.com'], icon: '🐦' },
    { name: 'Bilibili', domains: ['bilibili.com'], icon: '📺' },
    { name: 'TikTok', domains: ['tiktok.com'], icon: '🎵' },
    { name: 'Instagram', domains: ['instagram.com'], icon: '📷' }
  ],
  
  // 轮询间隔（毫秒）
  POLLING_INTERVAL: 2000,
  
  // 服务器健康检查间隔（毫秒）
  HEALTH_CHECK_INTERVAL: 30000
};

// 下载配置
export const DOWNLOAD_CONFIG = {
  // 默认文件扩展名
  DEFAULT_FILE_EXT: 'mp4',
  
  // 默认视频格式
  DEFAULT_FORMAT: 'best',
  
  // 支持的文件格式
  SUPPORTED_FORMATS: ['mp4', 'webm', 'mkv', 'avi', 'mov'],
  
  // 最大并发下载数
  MAX_CONCURRENT_DOWNLOADS: 3
};

// UI 配置
export const UI_CONFIG = {
  // 主题色
  PRIMARY_COLOR: '#3b82f6',
  
  // 动画持续时间
  ANIMATION_DURATION: 300,
  
  // Toast 显示时间
  TOAST_DURATION: 3000,
  
  // 每页显示的任务数
  TASKS_PER_PAGE: 10
};

const config = {
  API_CONFIG,
  APP_CONFIG,
  DOWNLOAD_CONFIG,
  UI_CONFIG
};

export default config; 